import { ImageLoader } from "next/image";

const customImageLoader: ImageLoader = ({ src, width }) => {
	return `/images-optimized/${src}-${width}.webp`;
};

export default customImageLoader;
